<script>
import { mapActions, mapGetters } from 'vuex'
import _get from 'lodash/get'
import retryOnce from '@utils/retryOnce'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLocationLoading: false,
      locationError: null,
      placeholderLocation: {
        JOB_NUMBER: '',
        CLIENT_NAME: '',
        IDENTIFIER: '',
        PHASE_: '',
        LOCATION: { street: 'Street', city: 'City', state: 'NY' },
        PERMIT_START_TIME: '',
        PERMIT_END_TIME: '',
      },
    }
  },
  computed: {
    ...mapGetters(['getLocationFromId', 'isAuthenticated']),
    location() {
      return this.getLocationFromId(this.id) || this.placeholderLocation
    },
    address() {
      const obj = this.location.LOCATION
      return obj ? `${obj.street}\n${obj.city}, ${obj.state}` : ''
    },
    permitHours() {
      let s = this.location.PERMIT_START_TIME
      let e = this.location.PERMIT_END_TIME
      let startString = s
        ? `${Number(s.hours)}:${s.minutes}${s.am_pm.toLowerCase()}`
        : ''
      let endString = e
        ? ` to ${Number(e.hours)}:${e.minutes}${e.am_pm.toLowerCase()}`
        : ''
      return `${startString}${endString}`
    }, // permitHours
    metaFields() {
      return [
        { title: 'Job Number', value: this.location.JOB_NUMBER },
        { title: 'Client', value: this.location.CLIENT_NAME },
        { title: 'Address', value: this.address },
        { title: 'Permit Hours', value: this.permitHours },
        {
          title: 'Default Phase',
          value: _get(
            this.location,
            'DEFAULT_PHASE[0].identifier',
            'No Default Phase'
          ),
        },
        {
          title: 'Default Cost Code',
          value: _get(
            this.location,
            'DEFAULT_COST_CODE[0].identifier',
            'No Default Cost Code'
          ),
        },
      ]
    }, // metaFields
  },
  watch: {
    id: {
      async handler(id) {
        // A newer id or teardown takes over, so this load stops retrying and
        // leaves the loading and error state alone.
        const isCurrent = () => this.id === id && !this._isDestroyed
        this.isLocationLoading = true
        try {
          // A signed-out failure (expired session) won't recover on retry.
          await retryOnce(() => this.fetchLocation({ ID: id }), {
            shouldRetry: () => this.isAuthenticated && isCurrent(),
          })
        } catch (error) {
          if (!isCurrent()) {
            return
          }
          this.locationError = true
          throw Promise.reject(error)
        } finally {
          if (isCurrent()) {
            this.isLocationLoading = false
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['fetchLocation']),
  },
  render() {
    const {
      location,
      isLocationLoading,
      address,
      permitHours,
      metaFields,
      locationError,
    } = this
    return this.$scopedSlots.default({
      location,
      isLocationLoading,
      address,
      permitHours,
      metaFields,
      locationError,
    })
  },
}
</script>
